import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';

import { StyledDropdownOption } from '../../../components/Dropdown/styles';

export const StyledListDropdownOption = styled(StyledDropdownOption)`
  padding: 12px 16px;

  ${SWReactIcons} {
    margin-right: 10px;
    width: 20px;
    height: 20px;
  }
`;
